export enum ToastPosition {
  TopRight = 1,
  BottomRight = 2,
  BottomLeft = 3,
  TopLeft = 4,
  TopCenter = 5,
  BottomCenter = 6,
}
